import React from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import Button from 'gu-ui-kit/Button'
import Tooltip from 'gu-ui-kit/Tooltip'
import Typography from 'gu-ui-kit/Typography'
import styles from 'components/Header/subcomponents/TicketsCounter/ticket-notifications.module.scss'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { SET_DRAWER_STATE } from 'modules/App/types'
import DrawerFooterAnimatedIcon from 'components/Drawer/subcomponents/DrawerFooter/subcomponents/DrawerFooterAnimatedIcon'
import { useSidePanel } from 'modules/SidePanel'
import { TICKETS_PANEL_ID } from 'modules/Tickets/constants'

const TicketsCounter = ({ className, collapse = false }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { toggle } = useSidePanel()
  const { ticketsCounter = 0 } = useSelector(
    (state) => ({
      ticketsCounter: state.notifications?.counters?.ticket,
    }),
    shallowEqual,
  )

  const button = (
    <Button
      grey
      additionalIcon={
        ticketsCounter > 0 && (
          <Typography
            className={'unread'}
            component={'span'}
            variant={'Body-10'}
          >
            {ticketsCounter}
          </Typography>
        )
      }
      className={clsx(styles['tickets-button'], className)}
      size={'s'}
      startIcon={<DrawerFooterAnimatedIcon name={'messages'} />}
      title={collapse ? undefined : t('tickets::header')}
      variant={'ghost'}
      onClick={() => {
        dispatch({ type: SET_DRAWER_STATE, payload: { opened: false } })
        toggle(TICKETS_PANEL_ID)
      }}
    />
  )

  if (collapse) {
    return (
      <Tooltip
        placement={'right'}
        title={t('tickets::header')}
      >
        {button}
      </Tooltip>
    )
  }

  return button
}

export default TicketsCounter

TicketsCounter.propTypes = {
  className: PropTypes.string,
  collapse: PropTypes.bool,
}
